import AmplitudeClientHandler from '../handlers/client-handler';
import { isAmplitudeEnabled, } from './amplitude-environment';
// null wherever Amplitude is off, so callers can use `amplitude?.`.
export const getAmplitudeClient = (amplitudeEnvironment) => isAmplitudeEnabled(amplitudeEnvironment)
    ? AmplitudeClientHandler.instance
    : null;
//# sourceMappingURL=amplitude-client.js.map